<template>
  <div class="learn-rate-component">
    <van-collapse v-model="activeNames" icon="arrow" change="change">
      <van-collapse-item v-for="(item, index) in dataList" :key="item.id" :name="(index + 1).toString()" v-show="item.restLearningCourses.length > 0">
        <template #title>
          <div class="title">0{{ index + 1 }}</div>
          <div class="title-top">第{{ item && item.CNNumeral }}阶段</div>
          <div class="title-bottom">{{ item && item.displayName }}</div>
        </template>
        <div class="sub-stage">
          <div class="stage-name" :class="{ 'first-index': true }">
            <div class="stage-name-text">
              {{ item && item.displayName }}
            </div>
            <div class="stage-bottom-line"></div>
          </div>
        </div>
        <div class="sub-stage" v-for="(subNode, subIndex) in item.restLearningCourses" :key="subIndex">
          <task-cell-lite :task-data="subNode" :hide-bottom-line="subIndex === item.restLearningCourses.length - 1" v-bind="$attrs"></task-cell-lite>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import TaskCellLite from './TaskCellLite.vue'
// import { numToCapital, NoToChinese } from '../../../utils/util'
import { NoToChinese } from '../../../utils/util'
export default {
  name: 'LearnComponentLite',
  components: {
    TaskCellLite
  },
  data() {
    return {
      dataList: [],
      currentStage: '1',
      activeName: '',
      activeNames: ['1', '2', '3', '4']
    }
  },
  props: {
    initData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    initData: {
      handler(newValue, oldValue) {
        if (newValue) {
          //   console.log('newValue', newValue)
          this.init()
        }
      },
      deep: true, // 深度监听
      immediate: true
    }
  },
  methods: {
    init() {
      // 排序
      let arr = JSON.parse(JSON.stringify(this.initData))
      arr = arr.sort((a, b) => {
        return a.sequence - b.sequence
      })
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index]
        // console.log('element', element)
        element.CNNumeral = NoToChinese(index + 1)
        if (element.restLearningCourses) {
          if (element.restLearningCourses.length > 1) {
            element.restLearningCourses = element.restLearningCourses.sort((a, b) => {
              return a.sequence - b.sequence
            })
          }
        } else {
          element.restLearningCourses = []
        }
      }
      this.dataList = JSON.parse(JSON.stringify(arr))
    }
  }
}
</script>

<style lang="less" scoped>
.learn-rate-component {
  margin: 0 7px;
  border-radius: 5px;
  .sub-stage {
    border-bottom: 1px solid #eee;
    .stage-name {
      position: relative;
      margin: -1px -12px 0;
      width: 251px;
      height: 46px;
      line-height: 46px;
      border-top: 1px solid #e5e5e6;
      display: flex;
      align-items: center;
      justify-content: center;
      .stage-name-text {
        width: 235px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #656565;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &.first-index {
        border-top: none;
      }
      .stage-bottom-line {
        position: absolute;
        bottom: 1px;
        width: 251px;
        height: 1px;
        background: #eeeeee;
      }
    }
  }
  .sub-stage:first-child {
    border: none;
  }
  .sub-stage:last-child {
    border: none;
  }

  /deep/ .el-progress-bar__outer {
    height: 7.5px !important;
  }
  /deep/ .el-progress--line {
    width: 217px;
    float: left;
    margin-top: 3px;
  }
  /deep/ .el-progress-bar__inner {
    background: #EB1700;
  }
  /deep/ .el-progress__text div {
    font-size: 13px;
    font-weight: 500;
    color: #fe6a23;
    margin-left: 6px;
  }
  .van-cell {
    padding: 0;
  }
  /deep/ .van-collapse-item {
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    margin-bottom: 15px;
  }
  /deep/ .van-collapse-item__title {
    height: 57px;
    overflow: inherit !important;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    width: 102%;
  }
  .title-triangle-left {
    position: absolute;
    bottom: -7px;
    left: -7px;
    width: 7px;
    height: 7px;
    background: #999999;
    background: linear-gradient(45deg, transparent, transparent 50%, #999 51%, #999 100%);
  }
  .title-triangle-right {
    position: absolute;
    bottom: -7px;
    right: 0;
    width: 7px;
    height: 7px;
    background: linear-gradient(-45deg, transparent, transparent 50%, #999 51%, #999 100%);
    z-index: 1;
  }
  .title-top {
    font-size: 12px;
    font-weight: 500;
    margin: -3px 18px;
    height: 17px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #656565;
    line-height: 17px;
  }
  .title-bottom {
    width: 150px;
    height: 17px;
    font-size: 12px;
    font-family: AppleSystemUIFont;
    color: #1f262f;
    line-height: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 8px 0 0 17px;
  }
  .title-right {
    position: absolute;
    right: 45px;
    top: 10px;
  }
  /deep/ .van-circle__text {
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }
  /deep/ .van-collapse-item,
  /deep/ .van-collapse-item__wrapper,
  /deep/ .van-collapse-item__title {
    background: white;
    border-radius: 12px;
  }
  /deep/ .van-collapse-item__title--expanded {
    overflow: auto;
    border-radius: 0 12px 0 0;
  }
  /deep/ .van-cell .title {
    background: #EB1700;
    color: #ffffff;
    border-radius: 12px 0 0 12px;
    margin-left: -1px;
    position: absolute;
    // height: 100%;
    left: -6px;
    top: 0;
    z-index: 9;
    font-size: 20px;
    font-weight: bold;
    padding: 16.5px 6px;
    &.unfold {
      border-bottom-left-radius: 0;
    }
  }

  /deep/ .van-collapse-item__content {
    padding: 0 12px;
  }
  /deep/ .van-collapse-item__title--disabled .title {
    background: #e5e5e6;
    color: #666666;
    border-radius: 12px 0 0 12px;
  }
  /deep/ .van-badge__wrapper {
    display: flex;
    align-items: center;
    height: 100%;
  }
  /deep/ .van-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
  }

  .circle-max /deep/ .van-circle__text {
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
    font-size: 10px;
    transform: none;
  }
  .circle-normal /deep/ .van-circle__text {
    font-size: 12px;
    width: 118%;
    left: -3px;
  }
  .tr-font {
    line-height: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/LearnComponentLite.vue